import React from "react"

export default function Header() {
    return(
        <header>
            <img className="header--image" src={require (`./images/nav-sheep.png`) }></img>
            <h2 className="header--title">Sheep Counter</h2>
        </header>
    )
}